import React from "react";

import { Close } from "@mui/icons-material";
import { Box, Dialog, IconButton, Typography } from "@mui/material";

const MediaFilesViewerModal = ({ open, selectedFile, onClose }) => {
  const type = typeof selectedFile === 'string' ? selectedFile : selectedFile?.type;

  const isVideo = type?.includes("mp4");
  const isImage = type?.includes("png") || type?.includes("jpg") || type?.includes("jpeg") || type?.includes("webp");
  const isText = type?.includes("txt");
  const isPdf = type?.includes('pdf');

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDialog-paper": {
          margin: 0,
          height: "90vh",
          maxWidth: "none",
          maxHeight: "none",
          px: { xs: 3, md: 6 },
          borderRadius: "10px",
          width: { xs: "95vw", md: "85vw" },
          overflow: "auto",
        },
      }}
    >
      <Box px={0} py={2} gap={1} display="flex" bgcolor="white" alignItems="center" justifyContent="space-between" borderBottom="1px solid #D0D4E4">
        <Box display="flex" gap={1.5} alignItems="center">
          <Typography color="black" fontWeight={500} fontSize="18px">
            File
          </Typography>
        </Box>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </Box>
      {isVideo ? (
        <video controls src={typeof selectedFile === 'string' ? selectedFile : selectedFile?.url} type="mp4" width="100%" height="90%">
          Your browser does not support the video tag.
        </video>
      ) : isImage ? (
        <Box
          component="img"
          src={typeof selectedFile === 'string' ? selectedFile : selectedFile?.url}
          sx={{
            objectFit: "contain",
            mx: "auto",
            height: { md: "90%", sm: "90%", xs: "90%" },
            width: { md: "90%", sm: "90%", xs: "90%" },
          }}
        />
      ) : isText ? (
        <iframe src={`https://docs.google.com/viewer?url=${typeof selectedFile === 'string' ? selectedFile : selectedFile?.url}&embedded=true`} title="file" width="100%" height="700px"></iframe>
      ) : isPdf ? (
        <embed type="application/pdf" width="100%" height="750px" src="https://www.antennahouse.com/hubfs/xsl-fo-sample/pdf/basic-link-1.pdf" />
      ) : (
        <Box className='center' height='100%'>
          <Typography>File type not supported</Typography>
        </Box>
      )}
    </Dialog>
  );
};

export default MediaFilesViewerModal;
